import { render, staticRenderFns } from "./switching-sidebar.vue?vue&type=template&id=bc775fbc&scoped=true&lang=pug&"
import script from "./switching-sidebar.vue?vue&type=script&lang=js&"
export * from "./switching-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./switching-sidebar.vue?vue&type=style&index=0&id=bc775fbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc775fbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VNavigationDrawer})
